import { useT } from "../lib/i18n";

export default function LanguageToggle({ variant = "header" }) {
  const { lang, setLang, t } = useT();
  const next = lang === "fr" ? "en" : "fr";

  const base =
    "inline-flex items-center rounded-full border text-xs font-semibold tracking-wider uppercase transition-all select-none";
  const styles =
    variant === "header"
      ? "h-9 px-1 gap-0.5 bg-white/80 border-[#E5EBE5] backdrop-blur-md shadow-sm hover:shadow"
      : "h-8 px-1 gap-0.5 bg-white border-[#E5EBE5]";

  return (
    <button
      type="button"
      onClick={() => setLang(next)}
      data-testid="lang-toggle"
      aria-label={t("langToggle.switchTo")}
      title={t("langToggle.switchTo")}
      className={`${base} ${styles}`}
    >
      <span
        className={`px-2.5 h-7 flex items-center rounded-full transition-all ${
          lang === "fr"
            ? "bg-[#1B5E20] text-white shadow-sm"
            : "text-[#5C705E] hover:text-[#1B5E20]"
        }`}
        data-testid="lang-fr"
      >
        FR
      </span>
      <span
        className={`px-2.5 h-7 flex items-center rounded-full transition-all ${
          lang === "en"
            ? "bg-[#1B5E20] text-white shadow-sm"
            : "text-[#5C705E] hover:text-[#1B5E20]"
        }`}
        data-testid="lang-en"
      >
        EN
      </span>
    </button>
  );
}
